module.exports = __webpack_public_path__ + "img/gruppen_diagnose_09.4125781b.png";